var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguranca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 42C2.175 42 1.46875 41.7063 0.88125 41.1188C0.29375 40.5312 0 39.825 0 39V17.3C0 16.475 0.29375 15.7688 0.88125 15.1813C1.46875 14.5938 2.175 14.3 3 14.3H6.5V9.5C6.5 6.87167 7.42677 4.63125 9.2803 2.77875C11.1338 0.926251 13.3755 0 16.0053 0C18.6351 0 20.875 0.926251 22.725 2.77875C24.575 4.63125 25.5 6.87167 25.5 9.5V14.3H29C29.825 14.3 30.5312 14.5938 31.1187 15.1813C31.7062 15.7688 32 16.475 32 17.3V39C32 39.825 31.7062 40.5312 31.1187 41.1188C30.5312 41.7063 29.825 42 29 42H3ZM3 39H29V17.3H3V39ZM9.5 14.3H22.5V9.5C22.5 7.69443 21.8686 6.15972 20.6059 4.89585C19.3431 3.63195 17.8098 3 16.0059 3C14.202 3 12.6667 3.63195 11.4 4.89585C10.1333 6.15972 9.5 7.69443 9.5 9.5V14.3Z",
    fill: "#9E2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguranca);
export default __webpack_public_path__ + "static/media/seguranca.af8e6269540e5991a0515ccd8eb328ae.svg";
export { ForwardRef as ReactComponent };